import { Component, OnInit } from '@angular/core';
import {ReportIssueComponent} from '../report-issue/report-issue.component';
import {MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-change-user',
  templateUrl: './change-user.component.html',
  styleUrls: ['./change-user.component.css']
})
export class ChangeUserComponent implements OnInit {

  selectedOption: any;
  roles = [
    {value: 'admin', viewValue: 'Administrator'},
    {value: 'editor', viewValue: 'Editor'}
  ];

  updateRole = function () {
    this.dialogRef.close(this.selectedOption);
  };

  close = function () {
    this.dialogRef.close();
  };

  constructor(private dialogRef: MatDialogRef<ReportIssueComponent>) {
  }

  ngOnInit() {
  }

}
